const flexibleAmount = {
  linkId: 153298073,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "ewfsdgndsafb",
  linkName: "48056",
  expiryDate: "25 Aug, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/48056/LL_153298073",
  shortUrl: "https://paytm.me/YN-A5AP",
  smartPhone: false,
  templateInfo: "Grocery Bill",
  isPartialPayment: false,
  fields: [
    {
      name: "Test",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: false, validationType: "textValidation" },
      placeholder: "Test",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Email ID",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: { maxLength: "200", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
      placeholder: "Email ID*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "DOB",
      type: "Date",
      displayText: "",
      helpText: "afgasdadhasghdasgjdhaghdasghj",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        maxValue: "31/07/2020",
        minValue: "01/08/2018",
        isMandatoryValidation: true,
        validationType: "dateValidation"
      },
      subText: "afgasdadhasghdasgjdhaghdasghj",
      placeholder: "DOB*",
      isError: false,
      errorName: "",
      inputValue: ""
    },
    {
      name: "Amount",
      type: "Amount",
      displayText: "Enter Amount",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        minValue: "1",
        maxValue: "10000000",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      placeholder: "Enter Amount*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    }
  ],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
const fixedAmount = {
  linkId: 126619845,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "Testing",
  linkName: "46406",
  expiryDate: "06 Jul, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/46406/LL_126619845",
  shortUrl: "https://paytm.me/OQa-WWs",
  smartPhone: false,
  templateInfo: "Link for Terms and Conditions: https://paytm.business/theia/linkPaymentRedirect",
  isPartialPayment: false,
  fields: [
    {
      name: "First Name",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
      parentField: "Full Name",
      placeholder: "First Name*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Last Name",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
      parentField: "Full Name",
      placeholder: "Last Name*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Mobile Number",
      type: "Numeric",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        maxLength: "10",
        minLength: "10",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      placeholder: "Mobile Number*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Product fee",
      type: "Amount",
      displayText: "",
      helpText: "Select if you agree to T&C",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: {
        value: "1000",
        minValue: "0",
        maxValue: "10000000",
        isMandatoryValidation: false,
        validationType: "numberValidation"
      },
      subText: "Select if you agree to T&C",
      placeholder: "Product fee",
      isError: false,
      errorName: "",
      inputValue: "1000"
    }
  ],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
const allAmountFields = {
  linkId: 102275071,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "amtfield",
  linkName: "78666",
  expiryDate: "02 Jun, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/78666/LL_102275071",
  shortUrl: "https://paytm.me/6IW-irT",
  smartPhone: false,
  templateInfo: "TestP",
  isPartialPayment: false,
  fields: [
    {
      name: "Fixed amiunt",
      type: "Amount",
      displayText: "",
      helpText: "This is Fixed amount field",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        value: "50",
        minValue: "0",
        maxValue: "10000000",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      subText: "This is Fixed amount field",
      placeholder: "Fixed amiunt*",
      isError: false,
      errorName: "",
      inputValue: "50"
    },
    {
      name: "flexi Field",
      type: "Amount",
      displayText: "",
      helpText: "Amount flexible field",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: { minValue: "10", maxValue: "990", isMandatoryValidation: true, validationType: "numberValidation" },
      subText: "Amount flexible field",
      placeholder: "flexi Field*",
      isError: false,
      errorName: "",
      inputValue: ""
    },
    {
      name: "Quantity",
      type: "QuantityAmount",
      displayText: "",
      helpText: "Field with quantity",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        value: "50",
        minQuantity: "1",
        maxQuantity: "10",
        minValue: "1",
        maxValue: "10",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      subText: "Field with quantity",
      placeholder: "Quantity*",
      isError: false,
      errorName: "",
      inputValue: ""
    },
    {
      name: "test",
      type: "Amount",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        value: "1",
        minValue: "0",
        maxValue: "10000000",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      placeholder: "test*",
      isError: false,
      errorName: "",
      inputValue: "1",
      subText: ""
    }
  ],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};
const dropDownAmountField2 = {
  linkId: 153298073,
  merchantId: "qNLEbz38834473442956",
  merchantName: "Test1",
  linkDescription: "ewfsdgndsafb",
  linkName: "48056",
  expiryDate: "25 Aug, 2021",
  status: "PENDING",
  longUrl: "https://paytm.business/link/paymentForm/48056/LL_153298073",
  shortUrl: "https://paytm.me/YN-A5AP",
  smartPhone: false,
  templateInfo: "Grocery Bill",
  isPartialPayment: false,
  fields: [
    {
      name: "Test",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: { maxLength: "30", minLength: "3", isMandatoryValidation: false, validationType: "textValidation" },
      placeholder: "Test",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Email ID",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: { maxLength: "200", minLength: "3", isMandatoryValidation: true, validationType: "textValidation" },
      placeholder: "Email ID*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Gender",
      type: "Dropdown",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: { allowedValues: ["Male", "Female", "Others"] }
    },
    {
      name: "DOB",
      type: "Date",
      displayText: "",
      helpText: "afgasdadhasghdasgjdhaghdasghj",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        maxValue: "31/07/2020",
        minValue: "01/08/2018",
        isMandatoryValidation: true,
        validationType: "dateValidation"
      },
      subText: "afgasdadhasghdasgjdhaghdasghj",
      placeholder: "DOB*",
      isError: false,
      errorName: "",
      inputValue: ""
    },
    {
      name: "Amount",
      type: "Amount",
      displayText: "Enter Amount",
      helpText: "",
      orientation: "H",
      mandatory: true,
      size: 100,
      constraints: {
        minValue: "1",
        maxValue: "10000000",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      placeholder: "Enter Amount*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Uditanshu",
      type: "DropdownAmount",
      displayText: "Payable Plans",
      helpText: "",
      mandatory: false,
      constraints: {
        allowedValues: [
          {
            name: "udit1",
            value: "283"
          },
          {
            name: "udit2",
            value: "8834"
          },
          {
            name: "udit4",
            value: "908"
          },
          {
            name: "udiy5",
            value: "784"
          }
        ]
      },
      orientation: "H",
      size: "100"
    }
  ],
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "",
    partialLinkPayments: []
  }
};

const dropDownAmountField = {
  resultInfo: null,
  linkId: 45814,
  merchantId: "qa12FU97229952596781",
  merchantName: "Nitesh",
  imageName: null,
  imageData: null,
  linkDescription: "party",
  linkName: "abhi",
  amount: "99.00",
  amountMantissa: "99",
  amountExponent: "00",
  expiryDate: "15 Nov, 2024",
  status: "PENDING",
  longUrl: "https://pgp-qa5.paytm.in/link/paymentForm/abhi/LL_45814",
  shortUrl: "https://paytm.me/k-h5Jnw",
  smartPhone: false,
  customerName: "Abhi script",
  customerPhoneNo: "9957216576",
  customerEmail: "hello.family@paytm.com",
  templateInfo: "Detail",
  paidAmount: null,
  blockAmount: null,
  isPartialPayment: false,
  payableAmount: null,
  fields: [
    {
      name: "Name",
      type: "Text",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: {
        maxLength: "200",
        minLength: "3",
        isMandatoryValidation: false,
        validationType: "textValidation"
      },
      placeholder: "Name",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Number",
      type: "Numeric",
      displayText: "",
      helpText: "",
      orientation: "V",
      mandatory: false,
      size: 100,
      constraints: {
        maxLength: "3",
        minLength: "1",
        maxValue: "150",
        minValue: "0",
        isMandatoryValidation: false,
        validationType: "numberValidation"
      },
      placeholder: "Number",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Gender",
      type: "Dropdown",
      displayText: "",
      helpText: "This is help text",
      orientation: "V",
      mandatory: false,
      size: 100,
      constraints: {
        allowedValues: ["Male", "Female"],
        isMandatoryValidation: false,
        validationType: "listValidation"
      },
      subText: "This is help text",
      placeholder: "Gender",
      isError: false,
      errorName: "",
      inputValue: ""
    },
    {
      name: "Payment Plans",
      type: "DropdownAmount",
      displayText: "",
      helpText: "",
      orientation: "H",
      mandatory: false,
      size: 100,
      constraints: {
        allowedValues: [
          {
            value: "150",
            name: "quaterly plan"
          },
          {
            value: "400",
            name: "half yearly plan"
          },
          {
            value: "600",
            name: "Annual plan"
          }
        ],
        isMandatoryValidation: false,
        validationType: "listValidation"
      },
      placeholder: "Payment Plans",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Amount1",
      type: "Amount",
      displayText: "",
      helpText: "",
      orientation: "V",
      mandatory: true,
      size: 100,
      constraints: {
        maxValue: "100",
        minValue: "1",
        isMandatoryValidation: true,
        validationType: "numberValidation"
      },
      placeholder: "Amount1*",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    },
    {
      name: "Amount2",
      type: "Amount",
      displayText: "",
      helpText: "",
      orientation: "V",
      mandatory: false,
      size: 100,
      constraints: {
        maxValue: "100",
        minValue: "0",
        value: "5",
        isMandatoryValidation: false,
        validationType: "numberValidation"
      },
      placeholder: "Amount2",
      isError: false,
      errorName: "",
      inputValue: "",
      subText: ""
    }
  ],
  partialLinkPayments: null,
  triggerJSCheckout: false,
  maxTxnAmount: null,
  partialPayment: false,
  partialAmountData: {
    isPartialPayment: false,
    paidAmount: "",
    blockAmount: "",
    payableAmount: "",
    totalAmount: "99",
    partialLinkPayments: null
  }
};
module.exports = { flexibleAmount, fixedAmount, allAmountFields, dropDownAmountField };



// WEBPACK FOOTER //
// ../mock-app-data/form/amount-fields/index.js